import React from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  virusChecked?: boolean
}

export const VirusCheckStatus: React.FC<Props> = ({ virusChecked }) => {
  const { t } = useTranslation('eInvoiceDetails')

  const virusCheckTooltip = virusChecked
    ? t(
        'stepper.additionalDocuments.table.columns.virusChecked.options.success',
      )
    : t(
        'stepper.additionalDocuments.table.columns.virusChecked.options.notPerformed',
      )

  return (
    <span title={virusCheckTooltip}>
      {virusChecked ? (
        <i className="pi pi-check-circle text-white bg-green-500 border-circle p-1 text-sm" />
      ) : (
        <i className="pi pi-exclamation-triangle text-color bg-yellow-500 border-circle p-1 text-sm" />
      )}
    </span>
  )
}
